import { RemoteEconomicActivity } from "../../../../data/usecases/activity-economic/remote-activity-economy";
import { EconomicActivity } from "../../../../domain/models/economic-activity";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteEconomicActivity = (): EconomicActivity =>
  new RemoteEconomicActivity("/economic-activities", makeAxiosHttpClient());
